import { defineWebModule } from '@portal/web-sdk';
import { manifest } from '../manifest.js';
import { useChatUnread } from './shared.js';
import { en, vi } from './translations.js';

export const chatWebModule = defineWebModule({
  manifest,
  translations: { vi, en },
  routes: [
    { path: '/chat', component: () => import('./pages/ChatPage.js') },
    { path: '/chat/$channelId', component: () => import('./pages/ChatPage.js') },
  ],
  navBadges: { chat: useChatUnread },
  slots: {
    'employee.actions': () => import('./actions/MessageButton.js'),
    'project.actions': () => import('./actions/ProjectChatButton.js'),
  },
});
